import React, {useEffect, useState} from 'react';
import CartPageStyles from './CartPage.module.scss';
import ShopPageStyles from "../ShopPage/ShopPage.module.scss";
import {API_URL_PHOTO} from "../../constants";
import {useAppDispatch, useAppSelector, useMobile} from "../../utils";
import {
    clearCart,
    fetchCreateOrder,
    fetchPromo,
    removeFromCart,
    resetPromo,
    updateQuantity
} from "../../services/slices/CartSlice";
import {getUserId} from "../../services/localStorageService";
import Toast from "../../components/Toast/Toast";
import {useNavigate} from "react-router-dom";

const CartPage = () => {
    const cartItems = useAppSelector((state) => state.cartSlice.cart);
    const dispatch = useAppDispatch();
    const discount = useAppSelector((state) => state.cartSlice.discount);
    const [showToast, setShowToast] = useState(false);
    const [showToastDone, setShowToastDone] = useState(false);
    const [showToastFields, setShowToastFields] = useState(false);
    const [fullName, setFullName] = useState('');
    const [telegram, setTelegram] = useState('');
    const [agreePolicy, setAgreePolicy] = useState(false);
    const [sdekAddress, setSdekAddress] = useState('');
    const [promoCode, setPromoCode] = useState('');
    const exist = useAppSelector((state) => state.cartSlice.exist);
    const navigate = useNavigate();
    const isMobile = useMobile();

    useEffect(() => {
        if (!isMobile) navigate('/');
    }, [isMobile, navigate]);

    const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setFullName(e.target.value);
    const handleTelegramChange = (e: React.ChangeEvent<HTMLInputElement>) => setTelegram(e.target.value);
    const handleSdekAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => setSdekAddress(e.target.value);
    const handlePromoCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPromoCode(e.target.value);
        if (exist !== null) {
            dispatch(resetPromo());
            setShowToast(false);
        }
    };

    const handleIdTg = () => {
        window.location.href = "https://t.me/epatazhnost_bot";
    }

    useEffect(() => {
        if (exist === 0) {
            setShowToast(true);
            const timer = setTimeout(() => setShowToast(false), 3000);
            return () => clearTimeout(timer);
        }
    }, [exist]);

    const handleApplyPromo = () => {
        dispatch(fetchPromo(promoCode))
    };

    const handleDecreaseQuantity = (itemId: number, size: string | undefined) => {
        const item = cartItems.find((item) => item.id === itemId && item.size === size);
        if (item && item.quantity) {
            if (item.quantity === 1) {
                dispatch(removeFromCart({itemId, size}));
            } else {
                dispatch(updateQuantity({itemId, size, quantity: item.quantity - 1}));
            }
        }
    };

    const handleIncreaseQuantity = (itemId: number, size: string | undefined) => {
        const item = cartItems.find((item) => item.id === itemId && item.size === size);
        if (item && item.quantity) {
            dispatch(updateQuantity({itemId, size, quantity: item.quantity + 1}));
        }
    };

    const calculateTotal = () => {
        let sum = cartItems.reduce((total, item) => total + item.price * (item.quantity || 1), 0);
        return discount ? (sum * (100 - discount) / 100).toFixed(2) : sum;
    };

    const handleCreateOrder = async () => {
        if (!agreePolicy) {
            setShowToastFields(true);
            return;
        }

        if (!fullName.trim() || !telegram.trim() || !sdekAddress.trim() || !agreePolicy) {
            setShowToastFields(true);

            const timer = setTimeout(() => setShowToastFields(false), 3000);
            return () => clearTimeout(timer);
        }

        if (cartItems.length === 0) return;

        const orderItems = cartItems.map(item => ({
            title: item.name,
            size: item.size || 'вансайз',
            amount: item.quantity || 1,
            cost: item.price * (item.quantity || 1)
        }));

        const totalCost = cartItems.reduce((sum, item) =>
            sum + item.price * (item.quantity || 1), 0);

        const [firstName, lastName] = fullName.split(' ');

        const orderData = {
            items: orderItems,
            user: {
                identifier: getUserId(),
                first_name: firstName,
                last_name: lastName,
                telegram: telegram,
                sdek: sdekAddress
            },
            promocode: promoCode || undefined,
            total_cost: totalCost
        };

        try {
            await dispatch(fetchCreateOrder(orderData)).unwrap();
            dispatch(clearCart());
            setTimeout(() => setShowToastDone(true));
        } catch (error) {
            console.log(error);
            setTimeout(() => setShowToast(false), 3000);
        }
    };

    return (
        <div className={CartPageStyles.mobileCartPage}>
            {showToast && (
                <Toast
                    message={'Промокод недействителен'}
                    onClose={() => setShowToast(false)}
                    status={'error'}
                />
            )}
            {showToastFields && (
                <Toast
                    message={'Заполните обязательные поля'}
                    onClose={() => setShowToast(false)}
                    status={'error'}
                />
            )}
            {showToastDone && (
                <Toast
                    message={'Заказ успешно оформлен!'}
                    onClose={() => setShowToastDone(false)}
                    status={'success'}
                />
            )}
            <div className={ShopPageStyles.modalCartWrapper}>
                <div>
                    <p className={ShopPageStyles.modalCartTitle}>Твой заказик:</p>
                    <div className={ShopPageStyles.modalCartItemsWrapper}>
                        {cartItems.length !== 0 ? (cartItems.map((item, index) => (
                                <div key={index} className={ShopPageStyles.modalCartOrderItems}>
                                    <img src={API_URL_PHOTO + item.main_image} alt={item.name}
                                         className={ShopPageStyles.modalCartOrderItemPhoto}/>
                                    <div className={ShopPageStyles.modalCartOrderItemDescription}>
                                        <p className={ShopPageStyles.modalCartOrderItemName}>{item.name}</p>
                                        <p className={ShopPageStyles.modalCartOrderItemSize}> размерчик: {item.size}</p>
                                    </div>
                                    <div className={ShopPageStyles.modalCartOrderItemActions}>
                                        <img
                                            src={'./minus.svg'}
                                            alt={item.name}
                                            onClick={() => handleDecreaseQuantity(item.id, item.size)}
                                            style={{cursor: 'pointer'}}
                                            className={ShopPageStyles.modalCartOrderItemActionsMinus}
                                        />
                                        <p className={ShopPageStyles.modalCartOrderItemActionsSum}>{item.quantity}</p>
                                        <img
                                            src={'./plus.svg'}
                                            alt={item.name}
                                            onClick={() => handleIncreaseQuantity(item.id, item.size)}
                                            style={{cursor: 'pointer'}}
                                            className={ShopPageStyles.modalCartOrderItemActionsPlus}
                                        />
                                        <p className={ShopPageStyles.modalCartOrderItemActionsPrice}>{item.price} р.</p>
                                    </div>
                                </div>
                            )))
                            :
                            (
                                <div className={ShopPageStyles.modalCartOrderEmpty}>Пока тут пусто( </div>
                            )}
                    </div>

                    <div className={ShopPageStyles.modalCartOrderItemSumWrapper}>
                        <p className={ShopPageStyles.modalCartOrderItemSum}>Итого: {calculateTotal()} р.</p>
                    </div>

                </div>

                <div className={ShopPageStyles.inputWrapper}>

                    <input
                        placeholder={'Имя Фамилия'}
                        value={fullName}
                        onChange={handleFullNameChange}
                    />
                    <div className={ShopPageStyles.promoCodeWrapper}>
                        <input
                            placeholder={'Твой Telegram ID'}
                            value={telegram}
                            onChange={handleTelegramChange}/>

                        <div
                            className={ShopPageStyles.applyBtn}
                            onClick={handleIdTg}
                        >Узнать ID
                        </div>

                    </div>

                    <div className={ShopPageStyles.promoCodeWrapper}>
                        <input
                            placeholder={'Промокод'}
                            value={promoCode}
                            onChange={handlePromoCodeChange}/>
                        {exist === 1 ? (
                            <div
                                className={ShopPageStyles.applyBtnDone}
                            >Успешно!
                            </div>
                        ) : (
                            <div
                                className={ShopPageStyles.applyBtn}
                                onClick={handleApplyPromo}
                            >Применить
                            </div>
                        )}

                    </div>
                    <input
                        placeholder={'Адрес ближайшего СДЭК'}
                        value={sdekAddress}
                        onChange={handleSdekAddressChange}/>

                    <div className={ShopPageStyles.policyCheckboxWrapper} style={{margin: '16px 0'}}>
                        <label style={{display: 'flex', alignItems: 'center', fontSize: '14px'}}>
                            <input
                                type="checkbox"
                                checked={agreePolicy}
                                onChange={e => setAgreePolicy(e.target.checked)}
                                style={{marginRight: 8}}
                            />
                            Я соглашаюсь с&nbsp;
                            <a
                                href="/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{color: '#6C47FF', textDecoration: 'underline', fontWeight: 500}}
                            >
                                политикой конфиденциальности
                            </a>
                        </label>
                    </div>

                </div>
                <div
                    className={ShopPageStyles.btn}
                    onClick={handleCreateOrder}
                    style={{cursor: 'pointer'}}
                >ОФОРМИТЬ ЗАКАЗИК
                </div>
            </div>

        </div>
    );
};

export default CartPage;